import { render, staticRenderFns } from "./CheckoutPaymentStep.vue?vue&type=template&id=31d0654e"
import script from "./CheckoutPaymentStep.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentStep.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPaymentStep.vue?vue&type=style&index=0&id=31d0654e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports